import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { forgotPassword } from "../apis/forgotPassword";
import AuthLayout from "./auth/AuthLayout";
import Input from "./campaign/wizard/Input";
import "../App.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { APP_ROUTES } from "../constants/appRoutes";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await forgotPassword({ email });
    } catch {
      // Always proceed — do not reveal whether the email exists
    } finally {
      setSubmitting(false);
      navigate(`${APP_ROUTES.RESET_PASSWORD}?email=${encodeURIComponent(email)}`, {
        state: {
          message:
            "If an account exists for this email, a password reset code has been sent.",
        },
      });
    }
  };

  return (
    <AuthLayout>
      <h1 className="mb-2 text-center text-xl font-bold text-slate-900">Forgot password</h1>
      <p className="mb-6 text-center text-sm text-slate-600">
        Enter your email and we&apos;ll send you a 6-digit reset code if an account exists.
      </p>

      <form onSubmit={handleSubmit}>
        <Input
          label="Email address"
          labelIcon="envelope"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          wrapperClassName="mb-5"
        />

        <button
          type="submit"
          className="btn btn-primary-app w-full font-semibold"
          disabled={submitting}
        >
          {submitting ? "Sending…" : "Send reset code"}
        </button>
      </form>

      <p className="mt-5 text-center text-sm text-slate-600">
        <Link className="font-semibold text-slate-900 hover:text-slate-700" to={APP_ROUTES.HOME}>
          Back to home
        </Link>
      </p>
    </AuthLayout>
  );
};

export default ForgotPassword;
